import * as fromDatatype from '../datatype-library';

export interface bl_opdg_element_by_brand_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    opdg_element_hdr_guid: fromDatatype.GuidDataFieldInterface;
    name:fromDatatype.VarcharDatatypeInterface;
    qty:fromDatatype.NumericDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    label_hdr_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_opdg_element_by_brand_RowClass implements bl_opdg_element_by_brand_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    opdg_element_hdr_guid: fromDatatype.GuidDataFieldInterface;
    name:fromDatatype.VarcharDatatypeInterface;
    qty:fromDatatype.NumericDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    label_hdr_guid: fromDatatype.GuidDataFieldInterface;
}

